import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { BasicSelect,ModelSelect} from 'vue-search-select';

export default {
  name: 'LineHaulMaster',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
  },
  data: function() {
		return {
			statusType: '',
			statusName: '',
			statusCode: '',
      statusSearch: '',
      statusNameSearch:'',
			
      statusNameList:[],
      validateFlag: false,
			resultCount: 0,
			isLoading: false,
			useremail: '',
			statusTypeObjData: {
				value: "",
				text: ""
			},
      statusNameObjData:{
        value: "",
				text: ""
      },
			statusTypeList: [{
					value: '1',
					text: "Coloader"
				},

			],
      lhtemplateid:'',
      lhstatus :"",
      lhStatusCode:"",
      searchFlag :false,
      templateList: [],
      changestatus: '',
      lhreceivestatusid:'',
      statusNameUpdate:'',
      statusNameSearch:'',
      tlhreceivestatusid  :'',
      tlhStatusCode:'',
      lineHaulStatusModal:false,
      statusNameSearchStatus:false,
      groupLoading:false,
      updateStatusNameModal:false,
      disabled: false
		}
	},

	created: function() {},
	computed: {},
 
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;

    this.getAllStatusNameList();
       
  },

  methods: {

      selectedStatusType(statusData) {
			this.statusTypeObjData = statusData;
			this.statusType = statusData.text
			
		},

    selectedStatusNameSearch(statusNameData){
			this.statusNameObjData = statusNameData;
      this.statusSearch = statusNameData.value;
			this.statusNameSearch = statusNameData.text;

    },

    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getGroupTemplates()
    },

    getStatusNameRowData(data){
      if(data.isactive == false){
          disabled = true;
      }else{
        this.tlhreceivestatusid = data.lhreceivestatusid;
        this.tlhStatusCode = data.lhreceivestatuscode;
        this.updateStatusNameModal = true;
      }
    },

    closeStatusNameModal() {
      this.updateStatusNameModal = false;
    },

    getAllStatusNameList() {
      this.isLoading = true;
      var i = 0;
      this.input = ({})
      axios({
        method: 'Get',
        'url': apiUrl.api_url_hubops + 'getAllLhStatusName',
        'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoading = false;
					  const slist = result.data.ResultData;
					for (i = 0; i < slist.length; i++) {
						this.statusNameList.push({
							value: slist[i].lhreceivestatusid,
							text: slist[i].lhreceivestatusname
						})
					}
   
          }, error => {
            this.isLoading = false;
            console.error(error)
          })
      },
      

  //to Save Line Haul Status Master Code
  saveLineHaulStatusCode() {

					this.isLoading = true;
					this.input = ({
						type: this.statusType,
						lhStatusName: this.statusName,
						lhSatusCode: Number(this.statusCode),
						createdby: this.useremail
					})
          
					axios({
							method: 'POST',
							'url': apiUrl.api_url_hubops + 'createLineHaulMasterCode',
							'data': this.input,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
							}
						})
					.then(result => {
							this.isLoading = false;
							if (result.data.ResultCode == 100) {
								this.$alert('Line Haul Status Template Created Successfully', "", "success");
                this.getAllStatusNameList();
							}else{
								this.$alert(result.data.ReturnMessage, "", "error");
              }
							this.resetForm();
						}, error => {
              this.isLoading = false;
							console.error(error)
						})
				
			}

		,

    updateStatusName() {
      if (this.statusNameUpdate!= "") {
        this.input = ({
          lhreceivestatusid: this.tlhreceivestatusid ,
          lineHaulCode:this.tlhStatusCode,
          lineHaulStatusName: this.statusNameUpdate,
          modifiedBy: this.useremail,
        })
        this.isLoadingtable = true;
        axios({
            method: 'PUT',
            'url': apiUrl.api_url_hubops + 'updateLineHaulByStatusCode',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoadingtable = false;
            if (result.data.ResultCode == 100) {
              //this.$alertify.success('Parent HUb Updated Successfully')
              this.$alert('Status Name Updated Successfully', "", "success");
              this.statusNameList = [];
              this.getAllStatusNameList(); 
              this.getLineHaulTemplates();
              this.updateStatusNameModal = false;
              this.statusNameUpdate = '';
              this.statusNameObjData={
                  value: "",
                  text: ""
              }
              this.statusSearch = '';
              this.statusNameSearchStatus= ''; 
            }else{
              this.$alert(result.data.ReturnMessage, "", "error");
            }
          }, error => {
            this.isLoadingtable = false;
            console.error(error)
          })
      } else {
        //this.$alertify.error("Please Select Any HUb");
        this.$alert("Please Enter Status Name", "", "error");
        return false;
      }
    }
,
      resetForm() {
        this.statusType = '';
        this.statusName = '';
        this.statusCode = '';
        this.statusTypeObjData = {
          value: "",
          text: ""
        };
        this.$validator.reset();
        this.groupLoading=false;
      
      },

      onSubmitSearch: function() {
        this.$validator.validateAll('form-2').then((result) => {
          if (!result) {
            return false;
          }
        }).catch(() => {
          console.log('errors exist')
        });
      },

      	//validate all form fields on onsubmit()
        onSubmit: function() {
          this.$validator.validateAll('form-1').then((result) => {
              if (!result) {
                console.log('errors exist', this.errors);
                return false;
              } else {
                this.saveLineHaulStatusCode();
              }
            }).catch(() => {
              console.log('errors exist', this.errors);
            });
        }
        ,

      getLineHaulTemplates() {
        if (this.statusSearch == null || this.statusSearch == undefined || this.statusSearch == '') {
          return false;
        }
        if (this.statusSearch!= "") {
          
          this.totalRows = 0
          this.resultCount = 0;
          this.searchFlag = true;
          this.templateList = [];
          this.input = ({})
  
          axios({
              method: 'GET',
              'url': apiUrl.api_url_hubops + 'getLhCodeMasterDetails?' + '&lhreceivestatusid=' + this.statusSearch + '&lhreceivestatusname='+ this.statusNameSearch  + '&isActive=' + this.statusNameSearchStatus,
              'data': this.input,
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
              }
            })
            .then(result => {
              this.isLoadingtable = false;
              if (result.data.ResultCode == 100) {
                this.templateList = result.data.ResultData;
                this.resultCount = result.data.ResultData.length;
              } else {
                this.templateList = 0
                this.resultCount = 0
              }
            }, error => {
              console.error(error)
            })
        } else {
          this.$alert("Please Select Any Status Name", "", "error");
          return false;
        }
      },


        //to get target id in active/inactive modal
		getStatusRowData(data) {
			this.lineHaulStatusModal = true;
			this.lhtemplateid = data.lhreceivestatusid;
			this.lhstatus = data.isactive;
			this.lhStatusCode = data.lhreceivestatuscode;
			if (data.isactive == true) {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},

    closeStatusGroupModal() {
      this.lineHaulStatusModal = false
    },

    changeLineHaulMasterCodeStatus() {
			this.isLoading = true;
			if (this.changestatus == 'De-Activate') {
				var newStatus = false;
			} else {
				var newStatus = true;
			}
			this.input = ({
				lhreceivestatusid: this.lhtemplateid,
				lineHaulStatusCode: this.lhStatusCode,
				isActive: newStatus,
				modifiedBy: this.useremail,
			})

			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'deActivateLineHaulStatusCode',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.$alert('Line Haul Status Changed Successfully', "", "success");
					}else{
            this.$alert(result.data.ReturnMessage, "", "error");
          }
					this.groupStatusModal = false;
					this.getLineHaulTemplates();
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

    
  }
}


// WEBPACK FOOTER //
// ./src/views/components/LineHaulMaster/LineHaulMaster.js